import { useQuery } from '@apollo/client';
import { useMemo } from 'react';

import {
  AgendaAppointmentItemDataFragment,
  GetHealthProviderAgendaTestDocument,
} from '../../types/api/graphql';

export function useHealthProfessionalAppointmentsCheck(
  healthProfessionalId: string | null | undefined
) {
  const {
    data: healthProfessionalAppointmentCheckData,
    loading: healthProfessionalAppointmentCheckLoading,
  } = useQuery(GetHealthProviderAgendaTestDocument, {
    variables: {
      healthProfessionalId: healthProfessionalId ?? '',
    },
    skip: !healthProfessionalId,
  });

  const data = useMemo(() => {
    const agendas =
      healthProfessionalAppointmentCheckData?.healthProviderTestAgenda ?? [];

    return {
      hasAgendas: agendas.length > 0,
      agendas: agendas.map(x => {
        const appointments =
          x.existingAppointments?.map(
            option => option as AgendaAppointmentItemDataFragment
          ) ?? [];
        const hasAppointments = appointments.length > 0;
        return {
          healthProviderId: x.healthProviderId,
          hasAppointments,
          appointments,
        };
      }),
    };
  }, [healthProfessionalAppointmentCheckData?.healthProviderTestAgenda]);

  return {
    data,
    loading: healthProfessionalAppointmentCheckLoading,
  };
}
